export class CreateNewGroupDto {

	constructor(public GroupTableId: number,
				public GroupId: number,
				public TemplateId: number) {

	}
}